import React from "react"

const NotFound = () => {
  return (
        <div className="not-found-page">
            404: Not Found 😔
        </div>
  )
}

export default NotFound
